import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import Cookies from "js-cookie";

const COOKIE_CONSENT_KEY = "cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = Cookies.get(COOKIE_CONSENT_KEY);
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const handleChoice = (value) => {
    Cookies.set(COOKIE_CONSENT_KEY, value, { expires: 365 });
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60]">
      <div className="bg-gray-900/95 backdrop-blur border-t border-green-700/40 shadow-2xl">
        <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row items-start md:items-center gap-4">
          <p className="text-gray-300 text-sm flex-1">
            <FormattedMessage
              id="cookie.consent.message"
              defaultMessage="We use cookies to improve your browsing experience. By accepting, you agree to our cookie policy."
            />{" "}
            <a
              href="/cookies"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-400 hover:text-green-300 underline transition-colors"
            >
              <FormattedMessage id="cookie.consent.learnMore" defaultMessage="Learn more" />
            </a>
          </p>
          <div className="flex flex-col sm:flex-row gap-2 shrink-0">
            <button
              onClick={() => handleChoice("refused")}
              className="px-4 py-2 rounded-md text-sm text-gray-300 border border-gray-600 hover:border-gray-400 hover:text-white transition-colors"
            >
              <FormattedMessage id="cookie.consent.refuse" defaultMessage="Decline" />
            </button>
            <button
              onClick={() => handleChoice("accepted")}
              className="px-4 py-2 rounded-md text-sm text-white bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 transition-colors"
            >
              <FormattedMessage id="cookie.consent.accept" defaultMessage="Accept" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
